// extracted by mini-css-extract-plugin
export default {"location":"ProgramItem-module-c8c09f607bc22a598c80","break":"ProgramItem-module-b6e24c8e6675fbde1963"};